module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('encyclopedia.search')
    },
    on: {
      "keyup": _vm.autocomplete
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "search",
      "scale": "1.3"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65dddee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SearchInput.vue
// module id = 263
// module chunks = 0